// react import
import { onSnapshot, doc, updateDoc, arrayUnion } from "firebase/firestore";
import React, {
  useCallback,
  useEffect,
  useLayoutEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { db } from "../firebase";
import { commonAction, updatemessage } from "../slices/GameSlice";
import styled from "styled-components";
import { Search } from "../Search";
import toast from "react-hot-toast";
import { getAllInitials } from "../hooks/getInnitial";
import DragBoard from "./DragBoard";
import { CommonFooterButton } from "../common/CommonFooterButton";
import CommonBackground from "../common/CommonBackground";
import { userColors } from "../util/colors";
import ChatBackground from "../common/ChatBackground";
import CommonCell from "../common/CommonCell";
import { formatTime } from "../App";

// function countKoreanAndOthers(text) {
//   let koreanCount = 0;
//   let otherCount = 0;

//   for (let char of text) {
//     if (char >= "\uAC00" && char <= "\uD7A3") {
//       koreanCount++;
//     } else {
//       otherCount++;
//     }
//   }

//   return {
//     koreanCount: koreanCount,
//     otherCount: otherCount,
//   };
// }

const ChatInput = React.forwardRef(({ onKeyUp }, ref) => {
  const handleKeyPress = event => {
    if (event.key === "Enter") {
      event.preventDefault(); // ✅ 이 코드를 추가하여 엔터키를 방지한다.
    }
  };
  return <RoomInput ref={ref} onKeyUp={onKeyUp} onKeyDown={handleKeyPress} />;
});

// message = {text:string,order:number,userId:string,time:object}
const ChatRoom = () => {
  const dispatch = useDispatch();
  const [cellHeight, setCellHeight] = useState(0);
  const [cellWidth, setCellWidth] = useState(0);
  const [show, setShow] = useState(true);
  const {
    message,
    roomId,
    gameMode,
    wordMatchs,
    epilogueMatchs,
    initialConsonant,
    workMode,
    users,
    opacityOn,
  } = useSelector(state => state.GameSlice);
  const { userId, nickname } = useSelector(state => state.LoginInfoSlice);
  const inputRef = useRef();
  const containerRef = useRef();
  useEffect(() => {
    let first = true;
    if (roomId) {
      const docRef = doc(db, "game", `room${roomId}`);

      const unsubscribe = onSnapshot(docRef, async querySnapshot => {
        if (querySnapshot.exists()) {
          const message = querySnapshot.data().message;
          dispatch(updatemessage({ message }));
          if (first) {
            const users = querySnapshot.data().users;
            const check = users?.find(i => i.userId === userId);
            let order = 0;
            for (let i = 0; i < 8; i++) {
              if (!users.find(item => item?.order === i)) {
                order = i;
                break;
              }
            }
            const lastOrder = message[0]?.order + 1 || 1;
            const newMessage = {
              text: `님이 입장하였습니다.`,
              order: lastOrder,
              userId,
              nickname,
              type: "system",
              date: formatTime(new Date()),
            };
            updateDoc(docRef, {
              message: arrayUnion(newMessage),
            });
            if (!check) {
              updateDoc(docRef, {
                users: arrayUnion({ userId, nickname, order }),
              });
            }
            first = false;
          }
        } else {
        }
      });

      return () => unsubscribe();
    }
  }, [dispatch, roomId, userId, nickname]);

  const CliclHandler = useCallback(async () => {
    if (inputRef.current.value) {
      const value = inputRef.current.value;
      inputRef.current.value = "";

      if (value[0] === "/" && gameMode !== "오목") {
        const wordTargets = {
          훈민정음: "wordMatchs",
          끝말잇기: "epilogueMatchs",
        };
        const target = wordTargets[gameMode];
        const currentWords = { epilogueMatchs, wordMatchs };
        const searchWord = value.substring(1).replaceAll("\n", "");
        const check = currentWords[target]?.find(i => i?.word === searchWord);
        if (gameMode === "훈민정음") {
          if (check) {
            toast.error("중복 단어입니다.");
            return;
          }
          if (getAllInitials(searchWord) !== initialConsonant) {
            toast.error("초성이 틀립니다.");
            return;
          }
        }
        try {
          const item = await Search(searchWord).then(r => r.item);
          const filter = item?.filter(i => {
            return i.word?.replaceAll("-", "") === searchWord;
          });
          if (!filter?.length) {
            toast.error("검색 결과가 없습니다.");
          } else {
            const docRef = doc(db, "game", `room${roomId}`);

            const lastOrder =
              currentWords[target][currentWords[target].length - 1]?.order + 1;
            const value = {
              word: searchWord,
              order: lastOrder || 1,
              userId,
              nickname,
              type: "chat",
              date: formatTime(new Date()),
            };
            updateDoc(docRef, {
              [target]: arrayUnion(value),
            });
          }
        } catch {
          toast.error("통신에 실패했습니다 다시 시도해주세요");
        }
      } else {
        const docRef = doc(db, "game", `room${roomId}`);
        const lastOrder = message[0]?.order + 1;
        const newMessage = {
          order: lastOrder || 1,
          text: value,
          userId,
          nickname,
        };
        updateDoc(docRef, {
          message: arrayUnion(newMessage),
        });
      }
    }
  }, [
    roomId,
    message,
    gameMode,
    epilogueMatchs,
    wordMatchs,
    initialConsonant,
    userId,
    nickname,
  ]);

  const ClearMessage = useCallback(() => {
    const docRef = doc(db, "game", `room${roomId}`);

    updateDoc(docRef, {
      message: [],
    });
  }, [roomId]);
  const messageFilter = useMemo(() => {
    let arr = [];
    let currentId;
    for (let i = 0; i < message.length; i++) {
      const item = message[i];
      if (currentId !== item?.userId) {
        arr.push({
          userId: item?.userId,
          message: [],
          nickname: item?.nickname,
        });
        currentId = item?.userId;
      }
      arr[arr.length - 1].message.push(item);
    }
    return arr;
  }, [message]);

  const [backgroundLine, setBackgroundLine] = useState({});
  useLayoutEffect(() => {
    const newBackgroundRef = {};
    for (let i = 0; i < message.length; i++) {
      const item = message[i];

      if (item?.type !== "system") {
        const messageEl = document.getElementById(
          `${item.order}${item.userId}${item.type}message`
        );
        if (messageEl) {
          const width = messageEl?.children?.[0]?.offsetWidth;
          const height = messageEl?.children?.[0]?.offsetHeight;

          // 한글 + 나머지 문자 + 패딩
          const numberOfLines = Math.ceil(height / cellHeight);

          newBackgroundRef[item.order] = numberOfLines;

          messageEl.style.minHeight = `${numberOfLines * cellHeight}px`;
          messageEl.style.height = `${numberOfLines * cellHeight}px`;
          if (width >= cellWidth - 16) {
            messageEl.style.minWidth = `60%`;
          }
        }
      }
    }

    setBackgroundLine(newBackgroundRef);
  }, [show, message, cellHeight, cellWidth]);
  useEffect(() => {
    setTimeout(() => {
      if (containerRef.current) {
        const observer = new ResizeObserver(entries => {
          const container = entries[0];
          setCellHeight(container.contentRect.height / 20);
          setCellWidth((container.contentRect.width / 5) * 2);
        });

        observer.observe(containerRef.current);
      }
    }, 0);
  }, [containerRef, show]);

  useEffect(() => {
    setTimeout(() => {
      const container = containerRef.current;
      setCellHeight(container?.offsetHeight / 20 || 1);
      setCellWidth((container?.offsetHeight / 5) * 2);
    }, 0);
  }, [show]);

  useEffect(() => {
    const ReverseMode = e => {
      switch (e.key) {
        case "F1":
          e.preventDefault();
          dispatch(commonAction({ target: "workMode", value: !workMode }));
          setShow(workMode ? false : true);
          break;
        case "F2":
          e.preventDefault();
          dispatch(commonAction({ target: "opacityOn", value: !opacityOn }));
          break;
        default:
          break;
      }
    };

    document.addEventListener("keydown", ReverseMode);
    return () => document.removeEventListener("keydown", ReverseMode);
  }, [dispatch, workMode, opacityOn]);
  return (
    <DragBoard
      left={550}
      minHeight={"400px"}
      defaultSize={{ width: "400px", height: "500px" }}
      hideHandler={setShow}
      zIndex={2}
      enable={enable}
      footerContents={
        <div style={{ display: "flex", gap: "4px" }}>
          <CommonFooterButton onClick={CliclHandler}>전송</CommonFooterButton>
          <CommonFooterButton onClick={ClearMessage}>
            채팅 삭제
          </CommonFooterButton>
        </div>
      }>
      <Wrap>
        <ChatContainer ref={containerRef}>
          {message.length < 20 && <CommonBackground column={20} />}
          <AbsoluteDiv>
            <MessageContainer>
              {messageFilter.map((item, index) => {
                const self = userId === item.userId;
                const messages = item.message;
                const onlySystem = messages.every(i => i?.type === "system");
                const findUser = users.find(i => i?.userId === item.userId);
                const userColor = userColors[findUser?.order];

                return (
                  <MessageItemContainer key={`${index}messageContainerKeys`}>
                    {!self && !onlySystem && (
                      <div
                        style={{
                          display: "flex",
                          minHeight: cellHeight + "px",
                          width: "100%",
                          zIndex: 1,
                        }}>
                        {[0, 1, 2, 3, 4].map(thItem =>
                          thItem === 0 ? (
                            <NickSpan
                              style={{
                                minHeight: cellHeight + "px",
                                height: cellHeight + "px",
                              }}
                              key={`${thItem}${index}NickCellKey`}>
                              <UserDot style={{ backgroundColor: userColor }} />
                              {item.nickname}
                            </NickSpan>
                          ) : (
                            <CommonCell
                              styles={{
                                width: `20%`,
                                height: `${cellHeight}px`,
                              }}
                              key={`${thItem}${index}NickCellKey`}
                            />
                          )
                        )}
                      </div>
                    )}
                    <MessageBox key={`${index}messageItemKeys`}>
                      {messages.map((secondItem, secondIndex) => {
                        return (
                          <TotalMessageItem
                            $self={self}
                            key={`${secondItem.order}ChatMessageKeys${secondIndex}`}>
                            <MessageItem
                              $type={secondItem?.type}
                              id={`${secondItem.order}${secondItem.userId}${secondItem.type}message`}
                              style={{
                                minHeight: cellHeight + "px",
                                zIndex: 1,
                                // padding: "3px 5px",
                                boxSizing: "border-box",
                              }}>
                              <span>
                                {secondItem.type === "system" ? (
                                  <>
                                    <span style={{ fontWeight: 700 }}>
                                      {secondItem.nickname}
                                    </span>
                                    <span>{secondItem.text}</span>
                                  </>
                                ) : (
                                  secondItem.text
                                )}
                              </span>
                            </MessageItem>
                            {secondItem?.type === "system" ? (
                              <div
                                style={{
                                  display: "flex",
                                  minHeight: cellHeight + "px",
                                  width: "100%",
                                  zIndex: 1,
                                }}>
                                {[0, 1, 2, 3, 4].map(thItem => (
                                  <CommonCell
                                    styles={{
                                      width: `20%`,
                                      height: `${cellHeight}px`,
                                    }}
                                    key={`${thItem}${secondItem.order}syetemCellKey`}
                                  />
                                ))}
                              </div>
                            ) : null}
                            {backgroundLine[secondItem.order] ? (
                              <ChatBackground
                                line={backgroundLine[secondItem.order]}
                                cellHeight={cellHeight}
                              />
                            ) : null}
                          </TotalMessageItem>
                        );
                      })}
                    </MessageBox>
                  </MessageItemContainer>
                );
              })}
            </MessageContainer>
          </AbsoluteDiv>
        </ChatContainer>

        <ChatInput
          ref={inputRef}
          onKeyUp={e => {
            if (e.key === "Enter") {
              e.stopPropagation();
              CliclHandler();
            }
          }}
        />
      </Wrap>
    </DragBoard>
  );
};
export default ChatRoom;

const enable = {
  top: false,
  right: false,
  bottom: false,
  left: false,
  topRight: false,
  bottomRight: false,
  bottomLeft: false,
  topLeft: false,
};

const Wrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  position: relative;
  border-left: 1px solid #e0e0e0;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const ChatContainer = styled.div`
  height: calc(100% - 66px);
  position: relative;
  overflow-y: scroll;
  display: flex;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const AbsoluteDiv = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
`;

const RoomInput = styled.textarea`
  width: 100%;
  height: 66px;
  background-color: #fff;
  font-size: 12px;
  font-weight: 400;
  padding: 10px;
  box-sizing: border-box;
  z-index: 1;
  font-size: 12px;
  outline: none;
  border: none;
  border-right: 1px solid #e0e0e0;

  &:focus {
    outline: none;
  }
  resize: none;
`;

const MessageContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
  overflow-y: scroll;
  z-index: 1;
  &::-webkit-scrollbar {
    display: none;
  }
`;

const MessageBox = styled.div`
  display: flex;
  flex-direction: column-reverse;
  width: 100%;
`;

const TotalMessageItem = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: ${({ $self }) => ($self ? "end" : "start")};
`;

const MessageItem = styled.div`
  display: flex;
  min-width: 40%;
  height: auto;
  padding: 0 8px;
  font-size: 12px;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  color: #242424;
  max-width: 60%;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
  align-items: center;

  word-break: break-word;
  overflow-wrap: break-word;

  ${({ $type }) =>
    $type === "system" &&
    "min-width:100%; justify-content:center; background-color: #F5F5F5;"};
`;

const MessageItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const NickSpan = styled.span`
  font-size: 12px;
  font-weight: 400;
  box-sizing: border-box;
  min-width: 20%;
  padding: 0 5px;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  align-items: center;
  gap: 5.5px;

  background-color: #fff;
  ${({ $self }) => ($self ? "margin-left: auto;" : "margin-right: auto;")}
`;

const UserDot = styled.div`
  width: 5px;
  height: 5px;
  border-radius: 50%;
`;
